
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Input } from '@/components/ui/input';
import Button from '@/components/ui-elements/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface AdminMakeAdminDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  email: string;
  setEmail: (email: string) => void;
  handleMakeAdmin: () => Promise<void>;
  loading: boolean;
}

const AdminMakeAdminDialog: React.FC<AdminMakeAdminDialogProps> = ({
  isOpen,
  setIsOpen,
  email,
  setEmail,
  handleMakeAdmin,
  loading
}) => {
  const { t } = useTranslationUtils();

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('admin.makeAdminTitle')}</DialogTitle>
          <DialogDescription>
            {t('admin.makeAdminDescription')}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <label htmlFor="email" className="text-sm font-medium">
              {t('admin.emailAddress')}
            </label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="user@example.com"
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => setIsOpen(false)}
            disabled={loading}
          >
            {t('admin.cancel')}
          </Button>
          <Button 
            onClick={handleMakeAdmin} 
            disabled={loading}
          >
            {loading ? t('admin.processing') : t('admin.makeAdmin')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AdminMakeAdminDialog;
